import { useEffect } from 'react';
import { usePaymentSettingsStore } from '../store/paymentSettingsStore';

export function usePaymentSettings() {
  const settings = usePaymentSettingsStore((state) => state.settings);
  const isLoading = usePaymentSettingsStore((state) => state.loading);
  const error = usePaymentSettingsStore((state) => state.error);
  const loaded = usePaymentSettingsStore((state) => state.loaded);
  const loadPaymentSettings = usePaymentSettingsStore((state) => state.loadPaymentSettings);

  useEffect(() => {
    if (!loaded) {
      loadPaymentSettings();
    }
  }, [loaded, loadPaymentSettings]);

  return { settings, isLoading, error };
}
